export interface ChallanTextField {
  key: string;
  label: string;
  default: string;
  multiline?: boolean;
}

export const CHALLAN_TEXT_FIELDS: ChallanTextField[] = [
  { key: 'doc_label', label: 'Document Type Badge', default: 'Delivery Challan' },
  { key: 'copy_label_customer', label: 'Copy Tag — Customer Copy', default: 'Customer Copy' },
  { key: 'copy_label_office', label: 'Copy Tag — Office Copy', default: 'Office Copy' },
  { key: 'label_deliver_to', label: '"Deliver To" Label (customer address block)', default: 'Deliver To' },
  { key: 'label_date', label: '"Date" Label', default: 'Date' },
  { key: 'th_sl', label: 'Table — SL Header', default: 'SL' },
  { key: 'th_description', label: 'Table — Description Header', default: 'Description of Item' },
  { key: 'th_unit', label: 'Table — Unit Header', default: 'Unit' },
  { key: 'th_quantity', label: 'Table — Quantity Header', default: 'Quantity' },
  { key: 'th_remarks', label: 'Table — Remarks Header', default: 'Remarks' },
  { key: 'empty_items', label: 'Empty Items Text', default: 'No items' },
  { key: 'unit_piece', label: 'Quantity Unit — Singular', default: 'Piece' },
  { key: 'unit_pieces', label: 'Quantity Unit — Plural', default: 'Pieces' },
  { key: 'label_total_quantity', label: '"Total Quantity" Label (use {quantity}, {words}, {unit})', default: 'Total Quantity: {quantity} ({words}) {unit}' },
  { key: 'label_declaration', label: '"Declaration" Heading', default: 'Declaration' },
  {
    key: 'declaration_text',
    label: 'Declaration Paragraph (use {quantity}, {words}, {unit})',
    default:
      'This is to confirm that the above-mentioned {quantity} ({words}) {unit} have been handed over to the above-mentioned customer in good condition. The receiving party confirms that the stated quantity has been received and accepted.',
    multiline: true,
  },
  { key: 'label_handed_over_by', label: '"Handed Over By" Label', default: 'Handed Over By' },
  { key: 'label_received_by', label: '"Received By" Label', default: 'Received By' },
  { key: 'label_scan_to_connect', label: '"Scan to Connect" QR Caption', default: 'Scan to\nConnect', multiline: true },
  { key: 'thank_you_message', label: 'Footer — Thank You Message (use {brand})', default: 'Thank you for shopping with {brand}!' },
];

export function challanText(overrides: Record<string, string> | null | undefined, key: string, vars?: Record<string, string | number>): string {
  const override = overrides?.[key]?.trim();
  const base = override || CHALLAN_TEXT_FIELDS.find((f) => f.key === key)?.default || '';
  if (!vars) return base;
  return Object.entries(vars).reduce((s, [k, v]) => s.split(`{${k}}`).join(String(v)), base);
}
